<template>
  <div class="code-input">
    <div v-if="!doorKey" class="code">
      <div class="nr" v-for="(nr, index) in codeToShow" :class="{ active: index < acceptedCodes.length }" :key="index">{{nr}}</div>
    </div>
    <div v-if="!doorKey" class="add-button" @click="addCode">Lägg till kod <div class="float-right">+</div></div>
    <!--<input v-if="!doorKey" ref="inputc" v-model="code" type="number" class="nr-input" maxlength="4" max="9999">-->
    <div v-if="doorKey" class="door-key" :class="{ isopen: turnKey, isgone: keyGone  }"></div>
    <div v-if="doorKey && !door" class="add-button open-button" @click="openDoor">Öppna porten</div>
  </div>
</template>

<script>
import FireDb from '@/api/FireDb.js'
export default {
  name: 'CodeInput',
  data () {
    return {
      msg: 'Cloetta',
      code: null,
      inputFocus: false,
      finalCode: null,
      codes: [
        '1111',
        '2222',
        '3333',
        '4444',
        '5555'
      ],
      turnKey: false,
      acceptedCodes: [],
      doorKey: false,
      keyGone: false
    }
  },
  props: ['door'],
  computed: {
    codeToShow () {
      let coder = '12345'
      if (this.code !== null) {
        coder = this.code.toString() + coder.substr(coder.length - (coder.length - this.code.toString().length))
      }
      if (coder.length > 5) {
        coder = coder.substr(0, 5)
      }
      return coder.split('')
    }
  },
  watch: {
    //  Not used (!!)
    code () {
      if (this.code && this.code.toString().length === 4) {
        this.finalCode = this.code
        if (this.codes.indexOf(this.finalCode) >= 0) {
          this.doorKey = true
        } else {
          window.setTimeout(() => {
            alert('Du har angivet fel kod')
            this.code = null
          }, 50)
        }
      }
    },
    acceptedCodes () {
      if (this.acceptedCodes.length === 5) {
        this.doorKey = true
      }
    }
  },
  methods: {
    openDoor () {
      this.turnKey = true
      window.setTimeout(() => {
        this.$emit('correct', this.acceptedCodes)
        this.keyGone = true
      }, 1000)
    },
    setFocus () {
      this.$refs.inputc.focus()
    },
    padNum (number, size) {
      let sign = Math.sign(number) === -1 ? '-' : ''
      return sign + new Array(size).concat([Math.abs(number)]).join('0').slice(-size)
    },
    addCode () {
      let test = window.prompt('4 sista siffrorna: ', '')
      //  Kolla om koden finns
      this.checkIfCodeExists(test).then((accepted) => {
        if (accepted) {
          /* if (this.acceptedCodes.indexOf(test) >= 0) {
            alert('Du har redan använt den koden!')
          } */
          this.acceptedCodes.push(test)
        } else {
          if (test && test.length > 0) {
            alert('Du har angivet fel kod')
            this.addCode()
          }
        }
      })
    },
    checkIfCodeExists (code) {
      return new Promise((resolve, reject) => {
        FireDb.database().ref('/data/' + code).once('value', snapshot => {
          const code = snapshot.val()
          if (code === true) {
            resolve(true)
          } else {
            resolve(false)
          }
        })
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .code-input {
    margin-top: 6.5vh;
    display: inline-block;
    position: relative;
    font-size: 2.8vh;
    width: 100%;
  }
  .code {
    margin-bottom: 0.5vh;
    position: relative;
    z-index: 99;
    pointer-events: none;
  }
  .nr {
    display: inline-block;
    width: 8vh;
    height: 8vh;
    vertical-align: middle;
    padding-top: 2.2vh;
    box-sizing: border-box;
    background-color: #e5a505;
    color: #ffcf26;
    opacity: 0.2;
    position: relative;
    z-index: 99;
    font-weight: bold;
  }
  .nr.active {
    opacity: 1;
  }
  .door-key {
    width: 40vh;
    height: 8vh;
    margin: auto;
    background-image: url('./../assets/images/key.svg');
    background-size: auto 80%;
    background-position: center center;
    background-repeat: no-repeat;
    margin-bottom: 1vh;
    transition: all 1s linear;
  }
  .door-key.isopen {
    transform: translateY(-16vh);
  }
  .door-key.isgone {
    display: none;
  }
  @keyframes keymoving {
    0% {
      transform: translateY(0vh);
    }
    100% {
      transform: translateY(-15vh);
    }
  }
  .add-button {
    width: 40vh;
    border: 0;
    margin: auto;
    padding: 2.3vh;
    box-sizing: border-box;
    height: 8vh;
    text-transform: uppercase;
    font-weight: bold;
    text-align: left;
    background-color: #ffcf26;
    cursor: pointer;
    border-bottom: 0.6vh solid #e5a505;
  }
  .open-button {
    text-align: center;
  }
  .nr-input {
    width: 36vh;
    border: 0;
    margin: 0;
    padding: 2vh;
    box-sizing: border-box;
    height: 8vh;
    position: absolute;
    top: 0px;
    opacity: 0;
    z-index: 1;
    background-color: transparent;
    font-size: 2.8vh;
    font-size: 20px;
    color: #e5a505;
  }
  .float-right {
    float: right;
    font-size: 4vh;
    margin-top: -1vh;
  }
  @media only screen and (max-width : 768px) and (max-height: 400px) {
    .code {
      transform: scale(1.8);
      background-color: #ffcf26;
      z-index: 99999;
      box-shadow: 0px 0px 200px 200px rgba(240, 240, 240, 0.83);
    }
  }
  @media only screen and (min-width: 660px) {
    .add-button:hover {
      background-color: #e5a505;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CodeInput.vue